// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file entities/app/my_account/my_account.proto (package protos.entities.app.my_account, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { WorkLocation } from "../../../general/work_location_pb";
import { file_general_work_location } from "../../../general/work_location_pb";
import type { ShowcaseLayoutType } from "../../../accounts/showcase_layout_type_pb";
import { file_accounts_showcase_layout_type } from "../../../accounts/showcase_layout_type_pb";
import type { Contact } from "./contact_pb";
import { file_entities_app_my_account_contact } from "./contact_pb";
import type { InfoSheet } from "./info_sheet_pb";
import { file_entities_app_my_account_info_sheet } from "./info_sheet_pb";
import type { JobAlerts } from "./job_alerts_pb";
import { file_entities_app_my_account_job_alerts } from "./job_alerts_pb";
import type { MyProfileCover } from "./my_profile_cover_pb";
import { file_entities_app_my_account_my_profile_cover } from "./my_profile_cover_pb";
import type { Settings } from "./settings_pb";
import { file_entities_app_my_account_settings } from "./settings_pb";
import type { SocialLinks } from "./social_links_pb";
import { file_entities_app_my_account_social_links } from "./social_links_pb";
import type { UnionMembership } from "./union_membership_pb";
import { file_entities_app_my_account_union_membership } from "./union_membership_pb";
import type { WorkFunctionData } from "./work_function_data_pb";
import { file_entities_app_my_account_work_function_data } from "./work_function_data_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file entities/app/my_account/my_account.proto.
 */
export const file_entities_app_my_account_my_account: GenFile = /*@__PURE__*/
  fileDesc("CihlbnRpdGllcy9hcHAvbXlfYWNjb3VudC9teV9hY2NvdW50LnByb3RvEh5wcm90b3MuZW50aXRpZXMuYXBwLm15X2FjY291bnQirAcKCU15QWNjb3VudBISCgphY2NvdW50X2lkGAEgASgJEgwKBG5hbWUYAiABKAkSCwoDYmlvGAMgASgJEg8KB3BmcF91cmwYBCABKAkSPgoGY292ZXJzGAUgAygLMi4ucHJvdG9zLmVudGl0aWVzLmFwcC5teV9hY2NvdW50Lk15UHJvZmlsZUNvdmVyEkEKFHNob3djYXNlX2xheW91dF90eXBlGAYgASgOMiMucHJvdG9zLmFjY291bnRzLlNob3djYXNlTGF5b3V0VHlwZRI4Cgdjb250YWN0GAcgASgLMicucHJvdG9zLmVudGl0aWVzLmFwcC5teV9hY2NvdW50LkNvbnRhY3QSTAoSbWFpbl93b3JrX2Z1bmN0aW9uGAggASgLMjAucHJvdG9zLmVudGl0aWVzLmFwcC5teV9hY2NvdW50LldvcmtGdW5jdGlvbkRhdGESTgoUb3RoZXJfd29ya19mdW5jdGlvbnMYCSADKAsyMC5wcm90b3MuZW50aXRpZXMuYXBwLm15X2FjY291bnQuV29ya0Z1bmN0aW9uRGF0YRIhChlkZWZhdWx0X3Byb2plY3RfY292ZXJfdXJsGAogASgJEj0KCmluZm9fc2hlZXQYCyABKAsyKS5wcm90b3MuZW50aXRpZXMuYXBwLm15X2FjY291bnQuSW5mb1NoZWV0EjgKEm1haW5fd29ya19sb2NhdGlvbhgMIAEoDjIcLnByb3Rvcy5nZW5lcmFsLldvcmtMb2NhdGlvbhI6CghzZXR0aW5ncxgNIAEoCzIoLnByb3Rvcy5lbnRpdGllcy5hcHAubXlfYWNjb3VudC5TZXR0aW5ncxI9Cgpqb2JfYWxlcnRzGA4gASgLMikucHJvdG9zLmVudGl0aWVzLmFwcC5teV9hY2NvdW50LkpvYkFsZXJ0cxJKChF1bmlvbl9tZW1iZXJzaGlwcxgPIAMoCzIvLnByb3Rvcy5lbnRpdGllcy5hcHAubXlfYWNjb3VudC5Vbmlvbk1lbWJlcnNoaXASLgoKY3JlYXRlZF9hdBgQIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASLgoKdXBkYXRlZF9hdBgRIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASQQoMc29jaWFsX2xpbmtzGGUgASgLMisucHJvdG9zLmVudGl0aWVzLmFwcC5teV9hY2NvdW50LlNvY2lhbExpbmtzYgZwcm90bzM", [file_google_protobuf_timestamp, file_general_work_location, file_accounts_showcase_layout_type, file_entities_app_my_account_contact, file_entities_app_my_account_info_sheet, file_entities_app_my_account_job_alerts, file_entities_app_my_account_my_profile_cover, file_entities_app_my_account_settings, file_entities_app_my_account_social_links, file_entities_app_my_account_union_membership, file_entities_app_my_account_work_function_data]);

/**
 * @generated from message protos.entities.app.my_account.MyAccount
 */
export type MyAccount = Message<"protos.entities.app.my_account.MyAccount"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string bio = 3;
   */
  bio: string;

  /**
   * @generated from field: string pfp_url = 4;
   */
  pfpUrl: string;

  /**
   * @generated from field: repeated protos.entities.app.my_account.MyProfileCover covers = 5;
   */
  covers: MyProfileCover[];

  /**
   * @generated from field: protos.accounts.ShowcaseLayoutType showcase_layout_type = 6;
   */
  showcaseLayoutType: ShowcaseLayoutType;

  /**
   * @generated from field: protos.entities.app.my_account.Contact contact = 7;
   */
  contact?: Contact | undefined;

  /**
   * @generated from field: protos.entities.app.my_account.WorkFunctionData main_work_function = 8;
   */
  mainWorkFunction?: WorkFunctionData | undefined;

  /**
   * @generated from field: repeated protos.entities.app.my_account.WorkFunctionData other_work_functions = 9;
   */
  otherWorkFunctions: WorkFunctionData[];

  /**
   * @generated from field: string default_project_cover_url = 10;
   */
  defaultProjectCoverUrl: string;

  /**
   * @generated from field: protos.entities.app.my_account.InfoSheet info_sheet = 11;
   */
  infoSheet?: InfoSheet | undefined;

  /**
   * @generated from field: protos.general.WorkLocation main_work_location = 12;
   */
  mainWorkLocation: WorkLocation;

  /**
   * @generated from field: protos.entities.app.my_account.Settings settings = 13;
   */
  settings?: Settings | undefined;

  /**
   * @generated from field: protos.entities.app.my_account.JobAlerts job_alerts = 14;
   */
  jobAlerts?: JobAlerts | undefined;

  /**
   * @generated from field: repeated protos.entities.app.my_account.UnionMembership union_memberships = 15;
   */
  unionMemberships: UnionMembership[];

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 16;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 17;
   */
  updatedAt?: Timestamp | undefined;

  /**
   * We'll remove this in the future so use a higher number
   *
   * @generated from field: protos.entities.app.my_account.SocialLinks social_links = 101;
   */
  socialLinks?: SocialLinks | undefined;
};

/**
 * Describes the message protos.entities.app.my_account.MyAccount.
 * Use `create(MyAccountSchema)` to create a new message.
 */
export const MyAccountSchema: GenMessage<MyAccount> = /*@__PURE__*/
  messageDesc(file_entities_app_my_account_my_account, 0);

